import { BAOCustomElement } from '@bao/custom-element'
import { getElement } from '@bao/utils'
import { MediaBreakpoints } from '@bao/media'

class LazyVideo extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.video = getElement('video', { context: this })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)
  }

  setupListeners () {
    const toggle = this.els?.toggle?.element

    if (!toggle) return

    const video = getElement('video', { context: this })

    this.listeners.add(toggle, 'click', () => {
      if (video.paused) {
        video.play()
        return
      }

      video.pause()
    })

    const syncToggle = () => {
      const label = video.paused
        ? toggle.dataset.playLabel
        : toggle.dataset.pauseLabel

      toggle.setAttribute('data-playing', String(!video.paused))

      if (label) toggle.setAttribute('aria-label', label)
    }

    this.listeners.add(video, 'play', syncToggle)
    this.listeners.add(video, 'pause', syncToggle)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    const hasCustomControls =
      this.closest('video-player') || this.els?.toggle?.element

    if (prefersReducedMotion) {
      this.video.removeAttribute('autoplay')

      if (!hasCustomControls) {
        this.video.setAttribute('controls', '')
      }

      this.video.pause()
    }

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()
    observer.unobserve(this.video)

    this.setAttribute('loaded', '')

    if (
      MediaBreakpoints.isSm ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
